export class FilenameRequest {
  folder!: string;
  filename!: string;
  userEmail!: string;
}
